import { PageTransferApprovalsOverview } from './Overview';

export const TRANSFER_APPROVALS = {
  TransferApprovalsOverview: PageTransferApprovalsOverview,
} as const;
